import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';

interface RankingListProps {
  movies: Movie[];
}

export default function RankingList({ movies }: RankingListProps) {
  return (
    <ol className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-100 overflow-hidden">
      {movies.map((movie, index) => (
        <li key={movie.id}>
          <Link
            to={`/detail/${movie.id}`}
            className="flex items-center gap-3 md:gap-4 p-3 md:p-4 hover:bg-background-200/60 transition-colors cursor-pointer"
          >
            <span
              className={`w-7 md:w-8 text-center font-heading font-extrabold text-lg md:text-xl shrink-0 ${
                index < 3 ? 'text-primary-400' : 'text-foreground-600'
              }`}
            >
              {index + 1}
            </span>
            <div className="relative w-12 h-16 md:w-14 md:h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
              <img
                src={movie.poster}
                alt={`${movie.title}海报`}
                title={`${movie.title} - 热门影视`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-foreground-100 truncate">{movie.title}</p>
              <p className="text-xs text-foreground-500 mt-1 truncate">
                {movie.year} · {movie.region} · {movie.genres[0]}
              </p>
              <p className="text-xs text-foreground-600 mt-1 hidden sm:flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {movie.playCount} 万次播放
              </p>
            </div>
            <span className="flex items-center gap-1 text-primary-400 text-sm font-semibold shrink-0">
              <i className="ri-star-fill text-xs"></i>
              {movie.rating.toFixed(1)}
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}